import React from 'react'
import './App.css'

import CardList from './CardList/CardList'

const App = () => (
  <div className="app">
    <CardList />
  </div>
)

export default App
